import type { FC, ReactNode } from "react";
import { Card, Stack, Typography } from "@mui/material";

interface EmptyListCardProps {
  title: string;
  /** Действие под текстом, например кнопка «Импорт» для пустого списка. */
  action?: ReactNode;
}

export const EmptyListCard: FC<EmptyListCardProps> = ({ title, action }) => (
  <Card
    elevation={0}
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 300,
      p: { xs: 5, sm: 12.5 },
    }}
  >
    <Stack spacing={3} alignItems="center">
      <Typography align="center" variant="h6">
        {title}
      </Typography>
      {action}
    </Stack>
  </Card>
);
